import { createSlice } from '@reduxjs/toolkit';
import { UATConstants } from 'src/Common/Models/UATConstants';

function getCopilotPinnedStateFromSessionStorage(): boolean {
  const item = sessionStorage.getItem(UATConstants.copilotPinnedState);
  if (item) {
    return JSON.parse(item);
  }

  sessionStorage.setItem(UATConstants.copilotPinnedState, String(true));
  return true;
}

function getShowCopilotWindowFromSessionStorage(): boolean {
  const item = sessionStorage.getItem(UATConstants.showCopilotWindow);

  if (item) {
    return JSON.parse(item);
  }

  // if session storage does not contain the key,
  // it means the user has not closed the copilot window, hence should set the value to true
  sessionStorage.setItem(UATConstants.showCopilotWindow, String(true));
  return true;
}

interface ICopilotState {
  isCopilotPinned: boolean;
  isCopilotWindowOpen: boolean;
}
const initialState: ICopilotState = {
  isCopilotPinned: getCopilotPinnedStateFromSessionStorage(),
  isCopilotWindowOpen: getShowCopilotWindowFromSessionStorage(),
};

export const copilotSlice = createSlice({
  name: 'copilotSlice',
  initialState,
  reducers: {
    setCopilotPinnedState: (state, action) => {
      state.isCopilotPinned = action.payload;
    },
    setCopilotWindowOpenState: (state, action) => {
      state.isCopilotWindowOpen = action.payload;
    },
  },
});

export const { setCopilotPinnedState, setCopilotWindowOpenState } = copilotSlice.actions;
